import Vue from 'vue'
import round from '../filters/round'

Vue.filter('round', round)
